import {inject, provider} from "react-ioc";
import {observer} from "mobx-react";
import React, {Component} from "react";
import {Container, ContainerDetails} from "app/modules/common/layout/components/containers";
import {PageTitleDetails} from "app/modules/common/layout/components/page-title";
import {Loading} from "app/modules/common/layout/components/loading";
import {Section, SectionName} from "app/modules/common/layout/components/details";
import {ApiClients} from "app/modules/company/services/AxiosBaseClient";
import {LoadingButton} from "@mui/lab";
import {Stack, Typography, Alert, Box, MenuItem} from "@mui/material";
import {SectionSelectField} from "app/modules/common/details/text-field";
import {AdminDevControllerStore} from "./AdminDevControllerStore";

@provider(AdminDevControllerStore)
@observer
export default class AdminDevController extends Component<any, any> {
    @inject adminDevControllerStore: AdminDevControllerStore;
    @inject apiClients: ApiClients;

    render() {
        if(this.adminDevControllerStore.isInitLoading) {
            return <Loading/>;
        }

        return <Container>
            <PageTitleDetails Title="Admin Dev Controller" Size={12}/>
            <ContainerDetails>
                <SectionName title="Development Tools" description="Admin tools for development and maintenance tasks"/>
                <Section>
                    <Stack spacing={3} direction={"column"}>
                        {this.adminDevControllerStore.lastResult && (
                            <Alert severity="info">
                                <Typography variant="body2">
                                    Last operation result: {this.adminDevControllerStore.lastResult}
                                </Typography>
                            </Alert>
                        )}

                        <Box>
                            <Typography variant="h6" gutterBottom>Data Management</Typography>
                            <Stack spacing={2} direction={"row"} sx={{ flexWrap: "wrap" }}>
                                <LoadingButton
                                    loading={this.adminDevControllerStore.isLoading}
                                    variant="contained"
                                    onClick={() => this.adminDevControllerStore.importZipCodes()}
                                    color="primary">
                                    Import Zip Codes
                                </LoadingButton>

                                <LoadingButton
                                    loading={this.adminDevControllerStore.isLoading}
                                    variant="contained"
                                    onClick={() => this.adminDevControllerStore.returnTimeZones()}
                                    color="primary">
                                    Get Time Zones
                                </LoadingButton>

                                <LoadingButton
                                    loading={this.adminDevControllerStore.isLoading}
                                    variant="contained"
                                    onClick={() => this.adminDevControllerStore.populateOrderMetrics()}
                                    color="primary">
                                    Populate Order Metrics
                                </LoadingButton>
                            </Stack>
                        </Box>

                        <Box>
                            <Typography variant="h6" gutterBottom>Vehicle Operations</Typography>
                            <Stack spacing={2} direction={"row"} sx={{ flexWrap: "wrap" }}>
                                <LoadingButton
                                    loading={this.adminDevControllerStore.isLoading}
                                    variant="contained"
                                    onClick={() => this.adminDevControllerStore.getAllOrders()}
                                    color="secondary">
                                    Get All Orders
                                </LoadingButton>

                                <LoadingButton
                                    loading={this.adminDevControllerStore.isLoading}
                                    variant="contained"
                                    onClick={() => this.adminDevControllerStore.refreshAllVehicleOrders()}
                                    color="secondary">
                                    Refresh All Vehicle Orders
                                </LoadingButton>

                                <LoadingButton
                                    loading={this.adminDevControllerStore.isLoading}
                                    variant="contained"
                                    onClick={() => this.adminDevControllerStore.refreshVehicleAvailability()}
                                    color="secondary">
                                    Refresh Vehicle Availability
                                </LoadingButton>

                                <LoadingButton
                                    loading={this.adminDevControllerStore.isLoading}
                                    variant="contained"
                                    onClick={() => this.adminDevControllerStore.getVehicleAvailabilityRedis()}
                                    color="secondary">
                                    Get Vehicle Availability Redis
                                </LoadingButton>
                            </Stack>
                        </Box>

                        <Box>
                            <Typography variant="h6" gutterBottom>System Maintenance</Typography>
                            <Stack spacing={2} direction={"row"} sx={{ flexWrap: "wrap" }}>
                                <LoadingButton
                                    loading={this.adminDevControllerStore.isLoading}
                                    variant="contained"
                                    onClick={() => this.adminDevControllerStore.setRecurringMasterJobs()}
                                    color="warning">
                                    Set Recurring Master Jobs
                                </LoadingButton>

                                <LoadingButton
                                    loading={this.adminDevControllerStore.isLoading}
                                    variant="contained"
                                    onClick={() => this.adminDevControllerStore.sylectusReadVehicles()}
                                    color="warning">
                                    Sylectus Read Vehicles
                                </LoadingButton>
                            </Stack>
                        </Box>

                        <Box>
                            <Typography variant="h6" gutterBottom>Email Management</Typography>
                            <Stack spacing={2} direction={"row"} sx={{ flexWrap: "wrap" }}>
                                <SectionSelectField
                                    field={this.adminDevControllerStore.formClearEmailBoxState.$.integrationId}
                                    width={"300px"}
                                    label={"Integration"}
                                    items={() => this.adminDevControllerStore.emailIntegrations.map((x) => <MenuItem value={x.id} key={x.id}>{x.name}</MenuItem>)}
                                />
                                <LoadingButton
                                    loading={this.adminDevControllerStore.isLoading}
                                    variant="contained"
                                    onClick={() => this.adminDevControllerStore.clearEmailBox()}
                                    color="error"
                                    disabled={!this.adminDevControllerStore.formClearEmailBoxState.$.integrationId.value}>
                                    Clear Email Box
                                </LoadingButton>
                            </Stack>
                        </Box>
                    </Stack>
                </Section>
            </ContainerDetails>
        </Container>;
    }

    async componentDidMount() {
        await this.adminDevControllerStore.init();
    }
}
